import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Btn } from "@/components/shared";
import { Download, X } from "lucide-react";
import { API } from "@/lib/api";

export function TutorialModal({ open, onClose, role = "client" }) {
  const r = role === "crew" ? "crew" : "client";
  const videoUrl = `${API}/public/guide/${r}/video`;
  const pdfUrl = `${API}/public/guide/${r}/pdf`;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#09090b] border-2 border-[#FF5722] text-white rounded-none max-w-2xl p-0 gap-0" data-testid="tutorial-modal">
        <DialogTitle className="sr-only">Getting started tutorial</DialogTitle>
        <DialogDescription className="sr-only">Watch the step-by-step tutorial video and download the PDF guide.</DialogDescription>
        <div className="flex items-center justify-between px-5 py-3 border-b-2 border-zinc-800">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#FF5722]">Getting Started Tutorial</div>
          <button data-testid="tutorial-close" onClick={onClose} className="text-zinc-500 hover:text-white"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">
          <video data-testid="tutorial-video" src={videoUrl} controls playsInline preload="metadata" className="w-full border-2 border-black bg-black aspect-video" />
          <p className="text-zinc-500 text-xs">A narrated walkthrough of the app. Prefer to read? Download the full PDF guide below.</p>
          <a href={pdfUrl} target="_blank" rel="noreferrer" data-testid="tutorial-pdf-link"><Btn className="w-full"><Download size={16} /> Download the PDF guide</Btn></a>
        </div>
      </DialogContent>
    </Dialog>
  );
}
